// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"392":"614ab0df","576":"2b2845cb","796":"33615bb3"}[chunkId] + ".chunk.js";
};